import { styled } from "@mui/material/styles";
import { Modal } from "@mui/material";

const StyledModal = styled(Modal)`
  display: flex;
  align-items: center;
  justify-content: center;

  & .MuiModal-backdrop {
    background-color: rgba(82, 90, 106, 0.4);
  }
`;

const StyledModalContainer = styled("div")`
  position: relative;
  width: 90%;
  max-height: 90%;
  max-width: 500px;
  background-color: ${({ theme }) => theme.palette.common.white};
  border-radius: 8px;
  margin: auto;
  border: none;
  outline: none;
  padding: 32px;
  box-sizing: border-box;

  & .modal-close {
    color: ${({ theme }) => theme.palette.customGrey.dark};
    transition: all 0.2s linear;
    position: absolute;
    top: 10px;
    right: 10px;

    &:hover {
      @media (min-width: 1024px) {
        color: ${({ theme }) => theme.palette.primary.main};
        transition: all 0.2s linear;
      }
    }
  }
`;

const StyledModalConfirmationModal = styled("div")`
  display: flex;
  flex-direction: column;
  align-items: center;
`;

const StyledModalConfirmationModalImgContainer = styled("div")`
  display: flex;
  align-items: center;
  justify-content: center;
  width: 160px;
  height: 140px;
  margin-bottom: 16px;
`;

const StyledModalConfirmationModalImg = styled("img")`
  width: 100%;
  height: 100%;
  object-fit: contain;
  object-position: center;
`;

const StyledModalConfirmationModalContentContainer = styled("div")`
  width: 100%;
  max-height: calc(100vh - 550px);
  overflow: auto;
`;

const StyledModalConfirmationModalButtonsContainer = styled("div")`
  display: flex;
  flex-direction: column;
  align-items: center;
  width: 100%;
  gap: 8px;
  margin-top: 24px;
`;

export {
  StyledModal,
  StyledModalContainer,
  StyledModalConfirmationModal,
  StyledModalConfirmationModalImgContainer,
  StyledModalConfirmationModalImg,
  StyledModalConfirmationModalContentContainer,
  StyledModalConfirmationModalButtonsContainer,
};
